// 将十进制的颜色参数转为渐变颜色的参数
const colorToLinearGradient=(background_color)=>{

    const result=background_color.map((item)=>{
        let colorStart = `#${item.start_color.toString(16)}`
        let colorEnd = `#${item.enc_color.toString(16)}`
        let color={
            // colorValue:{
            //     values:[
            //         {
            //             type:'linearGradient',
            //             directions:['to','bottom'],
            //             values:[`#${item.start_color.toString(16)}`,`#${item.enc_color.toString(16)}`]
            //         }
            //     ]
            // },

            colorValue:'linear-gradient( ' + colorStart + ', ' + colorEnd + ')',
            name:item.color_name
        }
        return color
    })

    return result
}

const getFileSize=(file_size)=>{
    let fileSize=''
    if(!file_size[0]&&!file_size[1]){
        fileSize='无要求'
    }else if(!file_size[0]&&file_size[1]){
        fileSize=`不大于${(file_size[1]/1024).toFixed(0)} kb`
    }else if(file_size[0]&&!file_size[1]){
        fileSize=`不小于${(file_size[0]/1024).toFixed(0)} kb`
    }else{
        fileSize=`${(file_size[0]/1024).toFixed(0)} ~ ${(file_size[1]/1024).toFixed(0)} kb`
    }
    return fileSize
}

const getBackNumberByName=(name,colorList)=>{
    let back_number=null
    colorList.forEach((item,index)=>{
        if (item.name===name){
            back_number=index
        }
    })
    return back_number
}

const getDownloadInfoUtils=(params)=>{
    let bgColor = params.spec_add_params.background_color

    let elc_url = params.url||[]
    let print_url = params.url_print||[]

    console.log('print_url',print_url)
    elc_url=elc_url.length>0&&elc_url.map((item,index)=>{
        return {
            url:item,
            name:`电子照_${params.spec_name}_${bgColor[index].color_name}.jpg`
        }
    })
    print_url=print_url.length>0&&print_url.map((item,index)=>{
        return {
            url:item,
            name:`排版照_${params.spec_name}_${bgColor[index].color_name}.jpg`
        }
    })
    let url_extra = params.url_extra&&getDownloadExtraInfoUtils(params.url_extra,bgColor)

    const url = elc_url.concat(print_url?print_url:[]).concat(url_extra?url_extra:[])
    return url
}

const getDownloadExtraInfoUtils=(params,bgColor)=>{
    let allUrl = params.map(item=>{
        let elc_url = item.urls

        let print_url = item.urls_print

        elc_url=elc_url.map((elcItem,elcIndex)=>{
            return {
                url:elcItem,
                name:`电子照_${item.name}_${bgColor[elcIndex].color_name}.jpg`
            }
        })
        print_url=print_url.map((printItem,printIndex)=>{
            return {
                url:printItem,
                name:`排版照_${item.name}_${bgColor[printIndex].color_name}.jpg`
            }
        })

        const url = elc_url.concat(print_url)
        return url
    })
    let allUrlNoChild=[]
    const recursion=(params)=>{
        params.forEach(item=>{
            if (Array.isArray(item)){
                recursion(item)
            }else{
                allUrlNoChild.push(item)
            }
        })

    }
    recursion(allUrl)
    return allUrlNoChild

}


const convertUrlToBase64=(url)=> {
    return new Promise(function (resolve) {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.src = url;
        img.onload = function () {
            const canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, img.width, img.height);
            const ext = img.src
                .substring(img.src.lastIndexOf(".") + 1)
                .toLowerCase();
            const dataURL = canvas.toDataURL("image/" + ext);
            const base64 = {
                dataURL: dataURL,
                type: "image/" + ext,
                ext: ext
            };
            resolve(base64);
        };
    });
}


const convertBase64UrlToBlob=(base64)=> {
    const parts = base64.dataURL.split(";base64,");
    const contentType = parts[0].split(":")[1];
    const raw = window.atob(parts[1]);
    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);
    for (let i = 0; i < rawLength; i++) {
        uInt8Array[i] = raw.charCodeAt(i);
    }
    return new Blob([uInt8Array], { type: contentType });
}


const myBrowser=()=> {
    const userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    if (userAgent.indexOf("OPR") > -1) {
        return "Opera";
    } //判断是否Opera浏览器 OPR/43.0.2442.991
    if (userAgent.indexOf("Firefox") > -1) {
        return "FF";
    } //判断是否Firefox浏览器  Firefox/51.0
    if (userAgent.indexOf("Trident") > -1) {
        return "IE";
    } //判断是否IE浏览器  Trident/7.0; rv:11.0
    if (userAgent.indexOf("Edge") > -1) {
        return "Edge";
    } //判断是否Edge浏览器  Edge/14.14393
    if (userAgent.indexOf("Chrome") > -1) {
        return "Chrome";
    } // Chrome/56.0.2924.87
    if (userAgent.indexOf("Safari") > -1) {
        return "Safari";
    } //判断是否Safari浏览器 AppleWebKit/534.57.2 Version/5.1.7 Safari/534.57.2
}

const uuid=()=> {
    let s = [];
    const hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";

    const uuid = s.join("");
    return uuid;
}



export default {
    colorToLinearGradient,
    getFileSize,
    getBackNumberByName,
    convertUrlToBase64,
    convertBase64UrlToBlob,
    myBrowser,
    getDownloadInfoUtils,
    uuid,
}
